import script from "./DetailHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DetailHeader.vue?vue&type=style&index=0&id=7e02c6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e02c6da"]])

export default __exports__